module.exports = __webpack_public_path__ + "static/merch5Front-f2287be727bf0ac3fe636d358950e79d.png";